import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type { ApiSearchQuery } from '@/lib/api/api-type-helper';

import type { PeopleGroup, SortableColumns } from './-types';

type QUERY = ApiSearchQuery<'/v2/people-groups', 'get'>;
type CATEGORY = Exclude<QUERY, undefined>['category'];
type CATEGORY_KEY = Exclude<CATEGORY, undefined>;

export const TabKey = {
  ALL: 'ALL',
  // UNNAMED: "UNNAMED",
  // DEPRECATED: "DEPRECATED",
} as const satisfies Record<CATEGORY_KEY, string>;

export type TabKey = EnumUnion<typeof TabKey>;

export const PEOPLE_GROUP_COLUMNS = {
  NAME: 'name',
  INTENDED_USE: 'intendedUse',
  TOTAL_PEOPLE: 'totalPeople',
  REFERENCED_ROLES: 'referencedRoles',
  MEMBERSHIP_EMPLOYEE: 'membershipEmployee',
  MEMBERSHIP_BOARD_MEMBER: 'membershipBoardMember',
  MEMBERSHIP_CONTRACTOR: 'membershipContractor',
  MEMBERSHIP_COLLABORATOR: 'membershipCollaborator',
  INDIVIDUALLY_INCLUDED: 'individuallyIncluded',
  INDIVIDUALLY_EXCLUDED: 'individuallyExcluded',
  MEMBERSHIP_ORGANIZATION: 'organizationUnits',
} as const satisfies Record<string, keyof PeopleGroup>;

export type OrderBy = Exclude<QUERY['orderBy'], undefined>;

export const SortColumns = ['NAME'] as const satisfies OrderBy[];

export const COLUMNS_TO_SORT_COLUMNS = {
  name: 'NAME',
} as const satisfies Record<SortableColumns, OrderBy>;

export const SORT_COLUMNS_TO_COLUMNS = {
  NAME: 'name',
} as const satisfies Record<OrderBy, SortableColumns>;
